import React, { useState, useCallback } from 'react';

export default function DropZone({ accept, onFile, label, hint, icon, compact = false, variant, style: externalStyle }) {
  const [active, setActive] = useState(false);

  const handleFile = useCallback((file) => {
    if (file) onFile(file);
  }, [onFile]);

  const onDrop = useCallback((e) => {
    e.preventDefault();
    setActive(false);
    const file = e.dataTransfer.files?.[0];
    handleFile(file);
  }, [handleFile]);

  const onInput = (e) => handleFile(e.target.files?.[0]);

  const inputId = `dropzone-${Math.random().toString(36).slice(2, 8)}`;

  const isBlue = variant === 'blue';
  const variantStyle = isBlue
    ? { border: '2px dashed #0071e3', background: '#fff', color: '#0071e3' }
    : {};

  const containerStyle = {
    ...(compact ? { padding: '12px 14px' } : {}),
    ...variantStyle,
    ...(externalStyle || {}),
  };

  const iconSize = compact ? 22 : undefined;
  const titleStyle = {
    ...(compact ? { fontSize: 13, margin: '6px 0 2px' } : {}),
    ...(isBlue ? { color: '#0071e3' } : {}),
  };
  const hintStyle = {
    ...(compact ? { fontSize: 12, margin: 0 } : {}),
    ...(isBlue ? { color: '#0071e3', opacity: 0.75 } : {}),
  };

  return (
    <div
      className={`dropzone ${active ? 'active' : ''}`}
      style={containerStyle}
      onDragEnter={(e) => { e.preventDefault(); setActive(true); }}
      onDragOver={(e) => { e.preventDefault(); setActive(true); }}
      onDragLeave={(e) => { e.preventDefault(); setActive(false); }}
      onDrop={onDrop}
      onClick={() => document.getElementById(inputId).click()}
    >
      {icon || (
        <svg
          className="dropzone-icon"
          viewBox="0 0 24 24" fill="none" stroke="currentColor"
          strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
          style={iconSize ? { width: iconSize, height: iconSize } : undefined}
        >
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
          <polyline points="17 8 12 3 7 8"/>
          <line x1="12" y1="3" x2="12" y2="15"/>
        </svg>
      )}
      <p className="dropzone-title" style={Object.keys(titleStyle).length ? titleStyle : undefined}>
        {label || 'Sleep een bestand hierheen'}
      </p>
      {hint !== '' && (
        <p className="dropzone-hint" style={Object.keys(hintStyle).length ? hintStyle : undefined}>
          {hint || 'of klik om te kiezen'}
        </p>
      )}
      <input
        id={inputId}
        type="file"
        accept={accept}
        style={{ display: 'none' }}
        onChange={onInput}
      />
    </div>
  );
}
